import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule, MatCheckboxModule, MatFormFieldModule, MatInputModule } from '@angular/material';
import { FormsModule } from '@angular/forms';
import { FuseSharedModule } from '@fuse/shared.module';
import { Ng2ImgMaxModule } from 'ng2-img-max';
import { LoginComponent } from 'app/main/pages/authentication/login/login.component';
import { MaterialModule } from './material.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { Login2Component } from 'app/main/pages/authentication/login-2/login-2.component';
const routes = [
    /* {
        path     : 'epw/detail',
        component: LoginComponent
    },
    {
        path     : 'epw/detail/:jobId',
        component: LoginComponent
    },
    {
        path     : 'epw',
        component: Login2Component
    },
    {
        path     : '',
        component: Login2Component
    }, */
];

@NgModule({
    declarations: [
        LoginComponent
    ],
    imports     : [
        RouterModule.forChild(routes),
        Ng2ImgMaxModule,
        MatButtonModule,
        FormsModule,
        NgxSpinnerModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatInputModule,
        MaterialModule,
        FuseSharedModule
    ]
})
export class LoginModule
{
}
